import React, { useEffect, useState } from "react";
import Cards from "../../components/AdminSideComponents/Cards";
import AnalyticsIcon1 from "../../Assets/Logos/expenses/AnalyticsIcon1.png";
import AnalyticsIcon2 from "../../Assets/Logos/expenses/AnalyticsIcon2.png";
import AnalyticsIcon3 from "../../Assets/Logos/expenses/AnalyticsIcon3.png";

import { MdAddCircle } from "react-icons/md";
import AddElectricityModal from "../../components/AdminSideComponents/ElectricitySection/AddElectricityModal";
import axios from "axios";

function Electricity() {
  const [addElectricityModalOpen, setAddElectricityModalOpen] = useState(false);
  const [allElectricity, setAllElectricity] = useState([]);
  const [buildings, setBuildings] = useState([]);
  const [buildingId, setBuildingId] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentMonth, setCurrentMonth] = useState();
  // const [startDate, setStartDate] = useState();

  const closeAddElectricityModal = () => {
    setAddElectricityModalOpen(false);
  };

  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of fetchAllBuildings: ", response.data.data);
        setBuildings(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
  }, []);

  useEffect(() => {
    getAllElectricityBills();
  }, [buildingId]);

  const getAllElectricityBills = async (id) => {
    setLoading(true);
    let data = "";
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/electricity/get_electricity/${id}?buildingId=${buildingId}`,
      headers: {},
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of getAllElectricity: ", response.data);
        setAllElectricity(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error: ", error);
        setLoading(false);
      });
  };

  console.log("allElectricity: ", allElectricity);
  // useEffect(() => {
  //   getAllElectricityBills();
  // }, [buildingId]);

  // useEffect(() => {
  //   getAllElectricityBills();
  // }, []);

  // if (!buildingId) {
  //   useEffect(() => {
  //     getAllElectricityBills();
  //   }, []);
  // }

  const items = [
    {
      name: "Electriciy till Date",
      // numberOfItems: analyticsExpense?.totalExpense
      //   ? "₹" + analyticsExpense?.totalExpense
      //   : "₹0",
      icon: AnalyticsIcon1,
    },
    {
      name: "Year End Electricity",
      // numberOfItems: analyticsExpense?.yearEndExpense
      //   ? "₹" + analyticsExpense?.yearEndExpense
      //   : "₹0",
      icon: AnalyticsIcon2,
    },
    {
      name: "Previous Month Electricity",
      // numberOfItems: analyticsExpense?.previousYearExpense
      //   ? "₹" + analyticsExpense?.previousYearExpense
      //   : "₹0",
      icon: AnalyticsIcon3,
    },
  ];
  return (
    <div className="electricityContainer p-6 bg-primarybgColor ">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Electricity
      </h1>
      {/* <Cards items={items} /> */}
      <div className="p-4  bg-white shadow-lg mt-6 rounded-lg overflow-hidden ">
        <div className="flex justify-between items-center mb-4 flex-col md:flex-row">
          <h1 className="text-[18px] mb-2 lg:mt-0 text-primaryTextColor sm:text-[24px] font-bold">
            Electricity
            <MdAddCircle
              onClick={() => setAddElectricityModalOpen(true)}
              className="rounded-lg  md:hidden cursor-pointer   text-primaryColor"
              size={40}
            />
          </h1>

          <div className="relative flex items-center gap-1 lg:gap-2">
            {/* <div className="flex items-center  w-full  sm:w-fit p-1  md:p-2  border border-gray-300">
              <input
                type="date"
                name="startDate"
                className="w-[50%] md:w-full rounded-lg focus: outline-none"
                placeholder="Start Date"
              />

              <input
                type="date"
                name="endDate"
                // value={endDate}
                // onChange={(e) => setEndDate(e.target.value)}
                className="w-[50%] md:w-full  rounded-lg  focus:outline-none "
                placeholder="End Date"
              />
            </div> */}

            <div className="relative">
              <select
                name="BuildingName"
                id="buildingName"
                className="border border-gray-300 w-full rounded-lg p-2 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                onChange={(e) => {
                  setBuildingId(e.target.value);
                }}
              >
                <option value="">Select Building</option>
                {buildings.map((b, index) => (
                  <option key={index} value={b._id}>
                    {b.nameBuilding}
                  </option>
                ))}
              </select>
            </div>

            <MdAddCircle
              onClick={() => setAddElectricityModalOpen(true)}
              className="rounded-lg cursor-pointer flex-shrink-0 hidden md:block text-primaryColor"
              size={40}
            />
          </div>
        </div>

        <div className="overflow-x-auto min-h-[70vh]">
          <table className="min-w-full bg-white  border-gray-200 rounded-md ">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl ">
                <th className="py-3 px-14 xl:px-6  text-[14px] text-left font-semibold text-primaryTextColor rounded-l-xl">
                  Date
                </th>

                <th className="py-3 px-14 xl:px-6  text-[14px] text-left font-semibold text-primaryTextColor rounded-l-xl">
                  Building Name
                </th>

                <th className="py-3 px-14 xl:px-6  text-[14px] font-semibold text-left text-primaryTextColor rounded-l-xl">
                  Room No.
                </th>

                <th className="py-3 px-14 xl:px-6  text-[14px] font-semibold text-left text-primaryTextColor rounded-l-xl">
                  No. of tenants
                </th>

                <th className="py-3 px-14 xl:px-6  text-[14px] font-semibold text-primaryTextColor text-left rounded-l-xl">
                  Amount
                </th>
              </tr>
            </thead>

            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide">
              {loading ? (
                //Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                  </tr>
                ))
              ) : allElectricity.length > 0 ? (
                allElectricity.map((electricity, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 text-sm text-primaryTextColor  ">
                      {new Date(electricity.date).toLocaleDateString("en-GB")}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor ">
                      {electricity.buildingId.nameBuilding}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor ">
                      R-F{electricity?.floorNo}
                      {String(electricity?.roomId?.roomNumber).padStart(3, "0")}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {
                        electricity.roomId.beds.filter(
                          (bed) => bed.isOccupied === true
                        ).length
                      }
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {electricity.amount}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="8"
                    className="py-40 px-6 text-lg text-center text-secondaryTextColor"
                  >
                    No Electricity bills available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <AddElectricityModal
        isOpen={addElectricityModalOpen}
        onClose={setAddElectricityModalOpen}
        getAllElectricityBills={getAllElectricityBills}
      />
    </div>
  );
}

export default Electricity;
